var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEgyptFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18.345,
    viewBox: "0 0 28 18.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0 -88.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M28,93.593H0V88.7a.455.455,0,0,1,.483-.42H27.517A.455.455,0,0,1,28,88.7v4.9Z",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M27.517,317.226H.483a.455.455,0,0,1-.483-.42v-4.9H28v4.9A.455.455,0,0,1,27.517,317.226Z",
    transform: "translate(0 -210.605)",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 28,
    height: 5.317,
    transform: "translate(0 94.79)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M230.494,213.134a.3.3,0,0,0-.4-.289l-.371.124-.09-.544a.668.668,0,0,0-.661-.56h-.347l-.363.447h.481l-.135.664-.392-.13a.3.3,0,0,0-.4.289v2.258l.54-.54-.255.764h-.286v.447h2.681v-.447h-.286l-.255-.764.54.54v-2.258Zm-1.564,2.481h-.36l.248-.661.113.144v.518Zm.447,0V215.1l.113-.144.248.661Zm-.223-.81a1.642,1.642,0,0,1-.663-1.34.716.716,0,0,1,1.326,0A1.642,1.642,0,0,1,229.153,214.805Z",
    transform: "translate(-215.153 -116.514)",
    fill: "#f0c727"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgyptFlag);
export default __webpack_public_path__ + "static/media/egypt-flag.5df3c61f08ac2360d099e51fcf89f9df.svg";
export { ForwardRef as ReactComponent };